import styles from './styles';
import CardHeader from '@material-ui/core/CardHeader';
import CardContent from '@material-ui/core/CardContent';
import Card from '@material-ui/core/Card';
import React from 'react';
import StageProgressGaugeChart from './StageProgressGaugeChart';
import StageProgressBarChart from './StageProgressBarChart';
import PercentageAbsoluteToggle from './toggles/PercentageAbsoluteToggle';

class StageProgress extends React.Component {
  state = {
    gauge: true,
  };

  render() {
    const { job, statistics } = this.props;
    const stages = (job.profile || {}).stages || [];
    const stage = stages[this.state.selectedStageIndex];

    /*
    //TODO read to card header
    action={<PercentageAbsoluteToggle
          value={this.state.gauge ? 'percentage' : 'absolute'}
          onChange={(value) => this.setState({ gauge: value === 'percentage' })}
        />}
     */
    return (<Card style={styles.card}>
      <CardHeader
        title="Stage Progress"

      />

      <CardContent>
        {this.state.gauge ? <StageProgressGaugeChart
          job={job}
          statistics={statistics}
          stages={stages}/> : <StageProgressBarChart
          job={job}
          statistics={statistics}
          stage={stage}
        />}
      </CardContent>
    </Card>);
  }
}

export default StageProgress;



// WEBPACK FOOTER //
// ./src/components/Reports/JobReport/StageProgress.js